import React from 'react'
import './filter-container.scss'
import { Column } from '@/components/layout/layout'
import useBemClass from '@/utils/hooks/useBEMClass'
import { layerManage } from '@/utils/layer'

interface FilterContainerProps {
    onConfirm: () => void
    onReset: () => void
    onCancel: () => void
    styles?: React.CSSProperties
    className?: string
}

const FilterContainer: React.FC<FilterContainerProps> = props => {
    const cls = useBemClass('filter-container')

    return (
        <>
            <div data-height-100p data-width-100p onClick={() => layerManage.pop()}></div>
            <Column className={`${cls('container')} ${props.className || ''}`} style={props.styles}>
                {props.children}
                <div className={cls('bottom')}>
                    <div className={cls('bottom', 'reset')} onClick={props.onReset}>
                        重置
                    </div>
                    <div className={cls('bottom', 'confirm')} onClick={props.onConfirm}>
                        确认
                    </div>
                </div>
            </Column>
        </>
    )
}

export default FilterContainer
